export function emptyJournalLine() {
    return {
        id: `tmp-${Date.now()}-${Math.random()}`,
        account_id: '',
        account_label: '',
        debit_amt: '',
        credit_amt: '',
        line_narration: '',
    };
}

export function sumDebits(lines) {
    return (lines || []).reduce((sum, line) => sum + (parseFloat(line.debit_amt) || 0), 0);
}

export function sumCredits(lines) {
    return (lines || []).reduce((sum, line) => sum + (parseFloat(line.credit_amt) || 0), 0);
}

export function validateJournalLines(lines) {
    if (!lines || lines.length < 2) {
        return 'At least two journal lines are required.';
    }
    let totalDr = 0;
    let totalCr = 0;
    for (let i = 0; i < lines.length; i += 1) {
        const line = lines[i];
        if (!line.account_id) {
            return `Line ${i + 1}: account is required.`;
        }
        const dr = parseFloat(line.debit_amt) || 0;
        const cr = parseFloat(line.credit_amt) || 0;
        if (dr > 0 && cr > 0) {
            return `Line ${i + 1}: enter either debit or credit, not both.`;
        }
        if (dr <= 0 && cr <= 0) {
            return `Line ${i + 1}: debit or credit amount must be greater than zero.`;
        }
        totalDr += dr;
        totalCr += cr;
    }
    if (Math.abs(totalDr - totalCr) > 0.05) {
        return `Total debit (${totalDr.toFixed(2)}) must equal total credit (${totalCr.toFixed(2)}).`;
    }
    if (totalDr <= 0) {
        return 'Journal total must be greater than zero.';
    }
    return null;
}

export function buildJournalLinePayload(lines) {
    return (lines || []).map((line) => ({
        account_id: line.account_id,
        debit_amt: parseFloat(line.debit_amt) || 0,
        credit_amt: parseFloat(line.credit_amt) || 0,
        line_narration: line.line_narration || '',
    }));
}

const LEDGER_GROUP_ORDER = [
    { key: 'ledger', label: 'Ledger Accounts' },
    { key: 'customer', label: 'Customers' },
    { key: 'vendor', label: 'Vendors' },
    { key: 'bank', label: 'Banks' },
];

export function buildLedgerSelectOptions(accounts) {
    return LEDGER_GROUP_ORDER
        .map(({ key, label }) => ({
            label,
            options: (accounts || [])
                .filter((account) => account.account_category === key)
                .map((account) => ({
                    value: account.id,
                    label: account.display_name || account.entity_name,
                })),
        }))
        .filter((group) => group.options.length > 0);
}

export function resolveAccountLabel(accounts, accountId, fallback = '') {
    const match = (accounts || []).find((account) => String(account.id) === String(accountId));
    if (!match) {
        return fallback;
    }
    return match.display_name || match.entity_name || fallback;
}
